import { modifyHref } from "@/components/Shared/HeaderNavTabs/utils"
import { pushAnalyticsObjToDataLayer } from "@/utils/helper"

/**
 * Click handler for anchor tags inside FAQ description HTML.
 *
 * This function receives the DOM `click` Event and locates the nearest
 * anchor (`<a>`) target. Implement your data-layer / navigation logic
 * inside this function.
 *
 * Usage (example):
 * ```js
 * import { onFaqDescriptionLinkClick } from 'components/DesignSystem/utils/faqLinkHandler'
 * const container = document.querySelector('.faq-description')
 * container.addEventListener('click', onFaqDescriptionLinkClick)
 * ```
 *
 * @param {MouseEvent} event - Click event
 * @param {Object} meta - Optional metadata about the FAQ item (e.g. teaser info)
 */
export function onFaqDescriptionLinkClick(event, meta = {}) {
  if (!event || !event.target) return

  const anchor = event.target.closest ? event.target.closest("a") : null
  if (!anchor) return

  const linkText = (anchor.textContent || "").trim()
  const url = anchor.href
  try {
    const eventInfo = {
      clickInternalLinks: "true",
      eventAction: `${meta?.pageType}:${
        meta?.mainTitle
      }:${linkText.toLowerCase()}`,
      eventMsg: "n/a",
      eventName: `${meta?.pageType}:${
        meta?.mainTitle
      }:${linkText.toLowerCase()}`,
      eventStatus: "n/a",
      eventType: "teaser",
      internalLinkName: linkText.toLowerCase(),
      internalLinkPosition: `${meta?.pageType}:teaser`,
      internalLinkType: `${meta?.pageType}:${meta?.mainTitle}`,
      internalLinkURL: modifyHref(url),
      internalLinkZoneName: `${meta?.pageType}:${meta?.mainTitle}`,
    }
    if (!url.includes("tel:")) {
      pushAnalyticsObjToDataLayer(eventInfo)
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("Failed to push FAQ link analytics", e)
  }
}

export default onFaqDescriptionLinkClick
